import { Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';

@Pipe({
  name: 'commercialImpactItemType',
})
export class CommercialImpactItemTypePipe implements PipeTransform {

  constructor(private i18NextPipe: I18NextPipe) {
  }

  transform(value: number, args?: any): any {
    const titles = [
      this.i18NextPipe.transform('CommercialImpactItemTypePipe.ProductionStream'),
      this.i18NextPipe.transform('CommercialImpactItemTypePipe.Labor'),
      this.i18NextPipe.transform('CommercialImpactItemTypePipe.Material'),
      this.i18NextPipe.transform('CommercialImpactItemTypePipe.Other')];
    return titles[value - 1];
  }
}
